import { render } from "./RegionStatBar.vue?vue&type=template&id=7b3170f5&scoped=true"
import script from "./RegionStatBar.vue?vue&type=script&lang=js"
export * from "./RegionStatBar.vue?vue&type=script&lang=js"

import "./RegionStatBar.vue?vue&type=style&index=0&id=7b3170f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3170f5"]])

export default __exports__